import React from "react"
import { MainCP } from "../../../Components/Ministerio-aprobacion/Ministerio-aprobacion-v2/MainCP"

const ViewMinisterioAPv2: React.FC = () => <MainCP/>

export default ViewMinisterioAPv2